import { Dialog, Grid, Typography, DialogContent, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";
import { buttonRed, lightcolor, rcolor } from "../../style2";

function InactivityMeter(props) {
    let auth = useAuth();
    const [lastAction, setLastAction] = useState(new Date());
    const [counter, setCounter] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const maxTimeout = props.maxTimeout || 1800;
    const warningAt = props.warningAt || 1740;

    const handleBodyEvent = (event) => {
        setCounter(0);
        setShowModal(false);
        setLastAction(new Date());
    }
    const history = useHistory();
    useEffect(() => {
        document.body.addEventListener('click', handleBodyEvent);
        //document.body.addEventListener('mousemove', handleBodyEvent);
        document.body.addEventListener('keydown', handleBodyEvent);
        document.body.addEventListener('wheel', handleBodyEvent);
        document.body.addEventListener('mousedown', handleBodyEvent);
        document.body.addEventListener('touchstart', handleBodyEvent);
        document.body.addEventListener('touchmove', handleBodyEvent);
        //document.body.addEventListener('visibilitychange', handleBodyEvent);
        document.body.addEventListener('MSPointerDown', handleBodyEvent);
        //document.body.addEventListener('MSPointerMove', handleBodyEvent);

        const interval = setInterval(() => {
            const date1 = new Date();
            const differenceInSeconds = Math.abs((date1.getTime() - lastAction.getTime()) / 1000);
            setCounter(counter + 1);
            //setShowModal(counter >= warningAt);
            setShowModal(differenceInSeconds >= warningAt);
            //console.log(`Last action time diferrence in seconds - ${differenceInSeconds}`);
            //if ((maxTimeout - counter) <= 0) {
            if (differenceInSeconds >= maxTimeout) {
                if (props.loginurl !== undefined && props.loginurl !== null) {
                    localStorage.clear();
                    history.push(props.loginurl);
                } else {
                    auth.logoutUser();
                }
                console.log("logout now");
            }
        }, 1000);

        return () => {
            document.body.removeEventListener('click', handleBodyEvent);
            //document.body.removeEventListener('mousemove', handleBodyEvent);
            document.body.removeEventListener('keydown', handleBodyEvent);
            document.body.removeEventListener('wheel', handleBodyEvent);
            document.body.removeEventListener('mousedown', handleBodyEvent);
            document.body.removeEventListener('touchstart', handleBodyEvent);
            document.body.removeEventListener('touchmove', handleBodyEvent);
            //document.body.removeEventListener('visibilitychange', handleBodyEvent);
            document.body.removeEventListener('MSPointerDown', handleBodyEvent);
            //document.body.removeEventListener('MSPointerMove', handleBodyEvent);
            clearInterval(interval);
        }
    })

    const renderTimeRemaining = () => {
        if (counter == 0)
            return "";
        let sec_num = parseInt(maxTimeout - counter, 10); // don't forget the second param
        let hours = Math.floor(sec_num / 3600);
        let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        let seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        return minutes + ':' + seconds;
    }

    if (showModal) {
        return <Dialog open={true} disableEscapeKeyDown={true} maxWidth="xs" fullWidth>
            <DialogContent sx={{ padding: 0 }}>
                <Grid container xs={12} sx={{ border: "1px solid " + rcolor, textAlign: "center", borderRadius: "5px", backgroundColor: lightcolor }}>
                    <Typography sx={{ padding: "20px", textAlign: "center", fontSize: "1rem" }}>
                        You are about to be logged out. Please click OK to continue using the current session.
                        <Box component="div" sx={{ padding: "4px", textAlign: "center", color: "red" }}>{renderTimeRemaining()}</Box>
                    </Typography>
                    <Box component="div" sx={{ textAlign: "center", width: "100%", paddingBottom: "20px" }}>
                        <button type="button" style={buttonRed}>Ok</button>
                    </Box>
                </Grid>
            </DialogContent>
        </Dialog>
    } else {
        return null;
    }
}

export default InactivityMeter;